import React from 'react';
interface RadioOption {
  value: string;
  label: string;
}
interface RadioGroupProps {
  name: string;
  label: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  tooltip?: string;
  autoAdvance?: boolean;
}
export function RadioGroup({
  name,
  label,
  options,
  value,
  onChange,
  required,
  tooltip,
  autoAdvance = false
}: RadioGroupProps) {
  const handleOptionSelect = (optionValue: string) => {
    onChange(optionValue);
  };
  return <div className="space-y-4" data-id="element-170">
      <label className="block text-base font-medium text-gray-900" data-id="element-171">
        {label}
        {required && <span className="text-red-600 ml-1" data-id="element-172">*</span>}
        {tooltip && <span className="ml-1 text-sm text-gray-500" data-id="element-173">{tooltip}</span>}
      </label>
      <div className="space-y-3" data-id="element-174">
        {options.map(option => <label key={option.value} className="flex items-center p-4 border border-gray-300 cursor-pointer hover:border-yellow-500 hover:shadow-[0_0_8px_rgba(234,179,8,0.4)] transition-all duration-300" data-id="element-175">
            <input type="radio" name={name} value={option.value} checked={value === option.value} onChange={() => handleOptionSelect(option.value)} className="w-4 h-4 text-yellow-500 border-gray-300 focus:ring-yellow-500" data-id="element-176" />
            <span className="ml-3 text-base text-gray-900" data-id="element-177">{option.label}</span>
          </label>)}
      </div>
    </div>;
}